import { render, staticRenderFns } from "./ServiceCategoryItem.vue?vue&type=template&id=778c50a1"
import script from "./ServiceCategoryItem.vue?vue&type=script&lang=js"
export * from "./ServiceCategoryItem.vue?vue&type=script&lang=js"
import style0 from "./ServiceCategoryItem.vue?vue&type=style&index=0&id=778c50a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports